import { AiOutlineShoppingCart } from 'react-icons/ai';
import { BsGrid1X2 } from 'react-icons/bs';
import {
  MdOutlinePersonalInjury,
  MdOutlineShoppingBasket,
} from 'react-icons/md';
import { TbNewSection, TbReportAnalytics } from 'react-icons/tb';
import { VscSettings } from 'react-icons/vsc';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  BackgroundColor,
  BrighterGreen,
  TextColor,
} from '../../../app/theme/tokens/colors';
import { usePortalStore } from '../../../stores/portalStore';
import { WorkspacePremiumOutlined } from '@mui/icons-material';
import { canAccessPatientsV2 } from '../../../modules/patients/usecases/v2/types';

const MenuTile = styled.div`
  background-color: white;
  color: ${TextColor};
  bottom: 0;
  top: 0;
  height: calc(100vh - 60px);
  transition: width 0.25s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  float: left;
  position: absolute;
  z-index: 3;
`;

const MenuItemTile = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  padding: 15px;
  cursor: pointer;
  border-left: 5px solid white;

  &:hover {
    color: ${BrighterGreen};
    font-weight: bold;
    background-color: ${BackgroundColor};
  }
`;

const IconTile = styled.div`
  margin-right: 10px;
  font-size: 20px;
  width: 28px;
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Menu = () => {
  const menuOpenState = usePortalStore((state) => state.ui.menuOpenState);
  const setMenuOpenState = usePortalStore((state) => state.setMenuOpenState);
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const currentUser = usePortalStore((state) => state.currentUser);
  const navigate = useNavigate();

  const goToPage = (url) => {
    if (isTabletOrMobile) {
      setMenuOpenState(false);
    }
    navigate(url);
  };

  const widthMenu = menuOpenState
    ? isTabletOrMobile
      ? '60%'
      : '200px'
    : '0px';

  const menuItems = [
    { label: 'Painel', Icon: BsGrid1X2, disabled: true },
    { label: 'Pedidos', Icon: AiOutlineShoppingCart, path: '/orders' },
    {
      label: 'Pacientes',
      Icon: MdOutlinePersonalInjury,
      path: '/patients',
    },
    ...(canAccessPatientsV2(currentUser)
      ? [
          {
            label: 'Gestão de Pacientes',
            Icon: MdOutlinePersonalInjury,
            path: '/patientsv2',
            premium: true,
          },
        ]
      : []),
    ...(currentUser.isAdmin || currentUser.accessReport
      ? [
          {
            label: 'Relatórios',
            Icon: TbReportAnalytics,
            path: '/report',
          },
        ]
      : []),
    ...(currentUser.isAdmin
      ? [
          { label: 'Balaios', Icon: MdOutlineShoppingBasket, path: '/baskets' },
          {
            label: 'Configurações',
            Icon: VscSettings,
            path: '/configuration',
          },
        ]
      : []),
  ];

  return (
    <MenuTile style={{ width: widthMenu }}>
      <div className="menu-panel">
        <div style={{ padding: '15px 0', borderBottom: 'solid 1px #efefef' }}>
          <MenuItemTile
            className="new-order"
            onClick={() => goToPage('/order/newOrder')}
          >
            <IconTile>
              <TbNewSection />
            </IconTile>
            <div>Novo pedido</div>
          </MenuItemTile>
        </div>

        <div>
          {menuItems.map(({ label, Icon, path, disabled, premium }) => (
            <MenuItemTile
              key={label}
              style={
                disabled
                  ? {
                      opacity: 0.6,
                      cursor: 'default',
                    }
                  : undefined
              }
              onClick={path ? () => goToPage(path) : undefined}
            >
              <IconTile>
                <Icon />
              </IconTile>
              {premium ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <span>{label}</span>
                  <WorkspacePremiumOutlined
                    fontSize="small"
                    titleAccess="Acesso Premium"
                  />
                </div>
              ) : (
                <div>{label}</div>
              )}
            </MenuItemTile>
          ))}
        </div>
      </div>
    </MenuTile>
  );
};
